import deadLetterEventService from './deadLetterEventService'

export default deadLetterEventService
